var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFavoritesHeaderHeartSvg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 28,
    viewBox: "0 0 32 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.3181 3.87022L15.8261 4.33795L16.3341 3.87022C17.6309 2.67626 20.2017 0.75 23.1739 0.75C27.4154 0.75 30.9022 4.30562 30.9022 8.72057C30.9022 10.0186 30.3192 11.3119 29.6678 12.3387C29.0247 13.3525 28.3679 14.0243 28.3294 14.0634L28.3268 14.0661L15.8261 26.9241L3.31862 14.0591L3.31863 14.0591L3.31584 14.0563C3.28113 14.021 2.6259 13.351 1.98356 12.338C1.33302 11.312 0.75 10.0187 0.75 8.72057C0.75 4.30562 4.23678 0.75 8.47826 0.75C11.4504 0.75 14.0213 2.67626 15.3181 3.87022Z",
    fill: "#3D2E24",
    fillOpacity: 0.3,
    stroke: "#FFDCA8",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFavoritesHeaderHeartSvg);
export default __webpack_public_path__ + "static/media/FavoritesHeaderHeartSVG.77c206ea0657bc9ac5429037b4f61d25.svg";
export { ForwardRef as ReactComponent };